import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppHeroComponent } from './components/app-hero/app-hero.component';
import { AwardsComponent } from './components/awards/awards.component';
@Component({
    selector: 'app-awards-acheivements',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        HeaderComponent,
        FooterComponent,
        AppHeroComponent,
        AwardsComponent
    ],
    templateUrl: './awards-acheivements.component.html',
    styleUrl: './awards-acheivements.component.scss',
})
export class AwardsAcheivementsComponent implements OnInit {
    selectedLanguage: any;
    constructor() {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }
}
